/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LDAPServerUser,
    LDAPServerUserFromJSON,
    LDAPServerUserFromJSONTyped,
    LDAPServerUserToJSON,
} from './';

/**
 * 
 * @export
 * @interface LDAPServerGroup
 */
export interface LDAPServerGroup {
    /**
     * 
     * @type {string}
     * @memberof LDAPServerGroup
     */
    dn: string;
    /**
     * 
     * @type {string}
     * @memberof LDAPServerGroup
     */
    name: string;
    /**
     * 
     * @type {Array<LDAPServerUser>}
     * @memberof LDAPServerGroup
     */
    users: Array<LDAPServerUser>;
}

export function LDAPServerGroupFromJSON(json: any): LDAPServerGroup {
    return LDAPServerGroupFromJSONTyped(json, false);
}

export function LDAPServerGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): LDAPServerGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dn': json['dn'],
        'name': json['name'],
        'users': ((json['users'] as Array<any>).map(LDAPServerUserFromJSON)),
    };
}

export function LDAPServerGroupToJSON(value?: LDAPServerGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dn': value.dn,
        'name': value.name,
        'users': ((value.users as Array<any>).map(LDAPServerUserToJSON)),
    };
}


